export default __webpack_public_path__ + "static/media/IconDesc_Smasher.256.3dc90362.png";